<template>
  <div
    v-if="btnRequirementsMet"
    class="w-100"
  >
    <Feedback
      :feedback="feedback"
      :dismissible="true"
    />

    <b-button
      :disabled="busy || ! hasCoordinates || disabled"
      variant="outline-primary"
      class="w-100 d-flex align-items-center"
      @click="handleGenerateViews"
    >
      <b-spinner
        v-if="busy"
        small
        variant="light"
      />
      <span class="mx-auto">{{ $t('processes.fields.generate_views') }}</span>
    </b-button>
  </div>
</template>

<script>
/**
 * TODO: Write a lambda that handles this server side,
 * TODO: so the file doesn't have to go through the browser?
 * TODO: Q: will timeouts be a factor?
 *
 * TODO: Lacks error handling
 */
import { uploadFile } from '@/services/aws.js'

import { getStreetViewStaticURL } from '@/services/streetview.js'
import { mapGetters } from 'vuex'

import Feedback from '@/components/form/Feedback.vue'

//import Vue from 'vue'

export default {
  name: 'AutomatedViewsBtn',
  components: { Feedback },
  props: {
    uuid: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    collectionType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      busy: false,
      feedback: {
        show: false,
        message: '',
        variant: 'danger',
      },
    }
  },
  computed: {
    ...mapGetters('realisation', ['getActiveRecordValues']),
    ...mapGetters('user', ['canAutomateViews']),
    ...mapGetters('realisations', ['getSelectedRecord']),
    ...mapGetters('chargingpoints', ['getChargingPointByUUID']),
    ...mapGetters('processes', ['getSelectedProcess']),

    record() {
      return this.getSelectedProcess || this.getSelectedRecord
    },
    location() {
      return this.isCustomProcess
        ? this.record.CurrentLocation
        : this.record.getLocation()
    },
    hasSideView() {
      return this.isCustomProcess
        ? this.location.Docs['SideView']?.length
        : this.location.hasDocOfType({ doctype: 'SideView' })
    },
    hasTopView() {
      return this.isCustomProcess
        ? this.location.Docs['TopView']?.length
        : this.location.hasDocOfType({ doctype: 'TopView' })
    },
    hasCoordinates() {
      return this.isCustomProcess
        ? Object.values(this.processCoordinates)?.length
        : this.location.hasCoordinates()
    },
    btnRequirementsMet() {
      return this.canAutomateViews && this.record && (! this.hasSideView || ! this.hasTopView)
    },
    isVlaanderen() {
      return ['vlaanderen', 'mechelen', 'engie'].includes(process.env.VUE_APP_TENANT)
    },
    collectionName () {
      return this.collectionType || 'Processes'
    },
    isAssetProcess () {
      return this.record.processType?.value !== 'realisation'
    },
    isCustomProcess () {
      return ['brussels', 'wallonia', 'takeover'].includes(this.record.processType?.value)
    },
    processCoordinates () {
      if (this.isCustomProcess) {
        const loc = this.location.location
        const address = loc.address || loc
        return { lat: address.latitude, lng: address.longitude }
      }

      const coordinates = this.location.Location
      return { lat: coordinates.Latitude, lng: coordinates.Longitude }
    }
  },
  methods: {
    async handleGenerateViews() {
      this.busy = true
      this.$store.dispatch('processes/disableSaveRecord', true)

      const data = {
        step: 'automatedViews',
        version: this.location.version,
        TopView: null,
        SideView: null,
      }

      if (! this.hasTopView) {
        data.TopView = await this.getAndUploadTopView()
      }

      if (! this.hasSideView) {
        data.SideView = await this.getAndUploadSideView()
      }

      // Generate file data or reset to NULL
      data.TopView = data.TopView
        ? this.record.getNextDocTypeId({ doctype: 'TopView' })
        : null
      data.SideView = data.SideView
        ? this.record.getNextDocTypeId({ doctype: 'SideView' })
        : null

      // Neither succeeded
      if (data.SideView === null && data.TopView === null) {
        this.feedback = {
          show: true,
          message: 'Er zijn geen automatische aanzichten beschikbaar',
        }

        this.busy = false
        return
      }

      // Update database
      const token = await this.$auth.getTokenSilently()
      const endpoint = this.isAssetProcess ? 'process_views' : 'realisation_views'
      const api = await fetch(`/api/${endpoint}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ref: this.record.ref,
          data,
        }),
      })
      if (! api.ok) {
        // console.log("error from db call")
        return
      }

      /**
       * TODO: Find a way to use this, without reseting the form data
       */
      const response = await api.json()

      // if (data.TopView) {
      //   Vue.set(this.location.Docs, 'TopView', [{
      //     id: data.TopView,
      //     ext: 'jpeg',
      //   }])
      //   this.record.Docs.TopView.push({
      //     id: data.TopView,
      //     ext: 'jpeg',
      //   })
      // }
      // if (data.SideView) {
      //   Vue.set(this.location.Docs, 'SideView', [{
      //     id: data.SideView,
      //     ext: 'jpeg',
      //   }])
      //   this.record.Docs.SideView.push({
      //     id: data.SideView,
      //     ext: 'jpeg',
      //   })
      // }

      const { TopView, SideView } = response.data.record.process.Docs

      this.record.Docs.TopView = TopView
      this.record.CurrentLocation.Docs.TopView = TopView
      this.record.Docs.SideView = SideView
      this.record.CurrentLocation.Docs.SideView = SideView

      if (this.isAssetProcess) {
        this.$store.dispatch('processes/setSelectedProcess', { process: this.getSelectedProcess })
      } else {
        this.$store.dispatch('realisations/setSelectedRecord', { record: this.record })
        this.$store.dispatch('realisation/setActiveRecordValues', { values: this.getActiveRecordValues })
      }

      this.busy = false
      this.$store.dispatch('processes/disableSaveRecord', false)
      this.$emit('refreshComponent')
    },
    async getAndUploadTopView() {
      try {
        const topviewsService = await import('@/services/topviews.js')

        const url = (this.isVlaanderen)
          ? topviewsService.getVlaanderenSatelite(this.processCoordinates)
          : topviewsService.getTopViewUrlFromPDOK(this.processCoordinates)

          return await this.uploadView({ doctype: 'TopView', url })
      } catch (e) {
        console.log('unable to obtain top view', e)
        return false
      }
    },
    async getAndUploadSideView() {
      try {
        let url = getStreetViewStaticURL(this.processCoordinates)

        return await this.uploadView({ doctype: 'SideView', url })
      } catch (e) {
        // console.log("unable to obtain top view")
        return false
      }
    },

    /**
     * Upload a view from a remote url by doctype
     */
    async uploadView({ doctype, url }) {
      if (! url) {
        // console.log("FAIL 1")
        return false
      }

      let view = await fetch(url)
      if (! view.ok) {
        // console.log("FAIL 2", response)
        return false
      }

      const file = await view.blob()
      const formData = new FormData()
      formData.append('type', doctype)
      formData.append('file', file)

      const response = await uploadFile({ file: formData, uuid: this.uuid })

      if (! response.ok) {
        // console.log("FAIL 4", response)
        return false
      }

      return true
    },
  },
}
</script>

<style>

</style>
